<router-outlet></router-outlet>

<app-toast></app-toast>
<app-alert></app-alert>
<app-alert-input></app-alert-input>
<app-loading></app-loading>

<button class="display-none" id="buyPlanBtn" data-bs-toggle="modal" data-bs-target="#buyPlan"></button>
<app-buy-plan-modal></app-buy-plan-modal>

<button id="inactivity" class="display-none" data-bs-toggle="modal" data-bs-target="#inactivityModal"></button>
<app-inactivity-modal></app-inactivity-modal>
